/**
 * Opens the booking notice's policy popup.
 *
 * The notice is rich text, so the merchant writes its links in the theme editor and
 * cannot put attributes on them. The trigger is therefore the link's own href: any
 * link inside the notice pointing at the fragment below opens the popup instead of
 * navigating. Keeping a real page URL in front of the fragment means the link still
 * goes somewhere useful if this script never runs.
 */
if (!customElements.get('collection-policy-modal')) {
  customElements.define(
    'collection-policy-modal',
    class CollectionPolicyModal extends HTMLElement {
      // connectedCallback must stay a prototype method — the Custom Elements API
      // reads lifecycle callbacks off the prototype when the element is defined.
      connectedCallback() {
        this.dialog = this.querySelector('[data-policy-modal-dialog]');
        if (!this.dialog) return;

        this.closers = Array.from(this.querySelectorAll('[data-policy-modal-close]'));
        this.opener = null;

        this.triggers = Array.from(document.querySelectorAll(`a[href$="${CollectionPolicyModal.FRAGMENT}"]`));
        this.triggers.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(link);
          });
        });

        this.closers.forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        // Bound once so the same reference can be removed again on close.
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };
      }

      static get FRAGMENT() {
        return '#booking-policy';
      }

      open(opener) {
        this.opener = opener || null;
        this.classList.add('is-active');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.onKeydown);

        // Focus lands on the dialog itself rather than the close button, so a screen
        // reader announces the title before the way out of it.
        //
        // Two frames, not one: the panel is `visibility: hidden` until the class
        // toggle's style recalc lands, and a hidden element cannot take focus. At the
        // first rAF the recalc is still pending, so focus() there fails silently and
        // falls back to <body>. Same wait the private classes popup documents.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.dialog.focus());
        });
      }

      close() {
        this.classList.remove('is-active');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.onKeydown);
        // Send focus back where it came from, so the tab order does not restart.
        if (this.opener) this.opener.focus();
        this.opener = null;
      }
    },
  );
}
